import React, { useContext } from 'react';
import './menuStyle.scss';
import './contentStyle.scss';
import { AppKeys, MessageType } from '../../core/localization';

import { LocaleCtx } from '../../contexts/locale.context';

interface OwnProps {
  title: MessageType;
}
type Props = OwnProps;

const Menu: React.FC<Props> = (props) => {
  const { translate } = useContext(LocaleCtx);

  const defaultTitle = translate(AppKeys.menu_notitle);
  const title = translate(props.title || defaultTitle);

  return (
    <div className="menucontent_wrapper">
      <span className="header">{title}</span>
      {props.children}
    </div>
  );
};
export default Menu;
